import useSWR from 'swr';

import { apiUrls } from 'services/api-urls';
import { fetcher } from 'services/fetcher';
import { DataDetailsEvtOrders, DataDetailsOrders } from 'types/DetailsMyOrders';

type ReturnType = {
  evtOrders?: DataDetailsEvtOrders;
  orders?: DataDetailsOrders;
};

export default function useOrderHistory(): ReturnType {
  const { data: evtOrders } = useSWR<DataDetailsEvtOrders>(
    apiUrls.getCustomerEvtOrders(),
    fetcher,
    {
      revalidateOnFocus: false,
    }
  );

  const { data: orders } = useSWR<DataDetailsOrders>(
    apiUrls.getCustomerOrders(),
    fetcher,
    {
      revalidateOnFocus: false,
    }
  );

  return {
    orders,
    evtOrders,
  };
}
